import WalletConnector from "../WalletConnector/WalletConnector";

function CardanoWalletSelector() {
  return <WalletConnector />;
}

export default CardanoWalletSelector;
